// blue
export const BLUE_FEF = '#D0DFEF';
export const BLUE_5F2 = '#D9E5F2';
export const BLUE_1F8 = '#F6F9FE';
export const BLUE_FAE = '#0E4FAE';
export const BLUE_2640 = '#102640';
export const BLUE_5EA0 = '#285EA0';
export const BLUE_52B4 = '#0052B4';
export const WHITE_FFF = '#FFFFFF';
export const WHITE_4F4 = '#F7F4F4';
export const WHITE_9F9 = '#FCF9F9';
export const WHITE_5F5 = '#F5F5F5';
export const WHITE_7F7 = '#f7f7f7';
export const WHITE_0F0 = '#f0f0f0';
export const GREY_3141 = '#103141';
export const GREY_B1B2 = '#AFB1B2';
export const GREY_4C4D = '#4F4C4D';
export const GREY_7070 = '#707070';
export const GREY_7979 = '#7B7979';
export const GREY_6263 = '#656263';
export const GREY_5050 = '#505050';
export const ORANGE_6A0A = '#EC6A0A';